'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowRight = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.987 12a2.411 2.411 0 0 0-.814-1.8L11.994.361a1.44 1.44 0 0 0-1.9 2.162l8.637 7.6a.25.25 0 0 1-.165.437H1.452a1.44 1.44 0 0 0 0 2.88h17.111a.251.251 0 0 1 .165.438l-8.637 7.6a1.44 1.44 0 1 0 1.9 2.161L23.172 13.8a2.409 2.409 0 0 0 .815-1.8z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M11.257 23.5a.5.5 0 0 1-.33-.875L22.428 12.5H.757a.5.5 0 0 1 0-1h21.669l-11.5-10.125a.5.5 0 1 1 .66-.75L23.23 10.876a1.472 1.472 0 0 1 .499 1.027.367.367 0 0 1 .006.162v.028a1.492 1.492 0 0 1-.505 1.033l-11.643 10.25a.5.5 0 0 1-.33.124z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.75 23.25a.752.752 0 0 1-.53-1.281l9.22-9.22H.75a.749.749 0 1 1 0-1.499h20.689l-9.22-9.22A.746.746 0 0 1 12.22.97c.141-.142.33-.22.53-.22s.389.078.53.22l10.5 10.5a.74.74 0 0 1 .163.245l.01.026a.73.73 0 0 1 0 .517l-.006.016a.755.755 0 0 1-.168.257L13.28 23.03a.743.743 0 0 1-.53.22z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowRight.displayName = 'IconArrowRight';
exports.default = IconArrowRight;